import './ClickFlower.css';
import { useState } from 'react';

export default function ClickFlower({

})

{
const [clicked, setClicked] = useState(false);
const handleClick = () => setClicked(true);

    return (
        <div className='flower-wrapper'>
            <img src='/Purple_flower.png'  className={`clickflower ${clicked ? 'clicked' : ''}`}
            onClick={handleClick}/>
            <div className={`flower_circle ${clicked ? 'circleclicked' : ''}`}/>
        </div>
    )
}